import { useNavigate } from "react-router-dom";
import { TextField, Button, CardMedia, Input, Tabs, Box, Tab, SelectChangeEvent } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import React, { ChangeEvent, useState } from "react";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const EditProfile = () => {

  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const handleNextTab = () => {
    if (valueTabs < 4) {
      setValueTabs((prev) => prev + 1);
    }
  };
  const [selectField1, setSelectField1] = React.useState("default");
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };
  const CustomTabPanel: React.FC<TabPanelProps> = ({
    children,
    value,
    index,
    ...other
  }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Add login logic here
    navigate("/dashboard");
  };
  const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });
  const [valueTabs, setValueTabs] = useState<number>(0);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  return (
    <>
      <div className="main_title">
        <h1>Edit Profile</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-profile")}>Manage Profile</button>
          {' '} - Edit Profile
        </p>
      </div>
      <Box className="custom_tabs1" sx={{ width: "100%", mt: 2 }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="view product tabs"
          className="custom_tabs_links"
        >
          <Tab label="General Details" {...a11yProps(0)} />
          <Tab label="Address Details" {...a11yProps(1)} />
          <Tab label="Bank Account Details" {...a11yProps(2)} />
          <Tab label="Document Section" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" onSubmit={handleSubmit}>
            {/* IMAGE UPLOAD */}
            <div className="gap_p">
              <div className="control_group w_100">
                <label htmlFor="icon-button-file">Upload Image</label>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = (event.target as HTMLInputElement).files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage("This field only accepts images.");
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/user_placeholder.png"
                          alt="icon"
                        />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              {/* OWNER NAME */}
              <div className="control_group w_33">
                <label htmlFor="ownerName">Owner Name</label>
                <TextField
                  id="ownerName"
                  name="ownerName"
                  placeholder="Enter Owner Name"
                  fullWidth
                />
              </div>

              {/* PHONE NUMBER */}
              <div className="control_group w_33">
                <label htmlFor="phoneNumber">Phone Number</label>
                <TextField
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Enter Phone Number"
                  type="tel"
                  fullWidth
                />
              </div>

              {/* EMAIL */}
              <div className="control_group w_33">
                <label htmlFor="email">Email Address</label>
                <TextField
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter Email Address"
                  fullWidth
                />
              </div>

              <div className="control_group w_33">
                <label htmlFor="storeName">Store Name</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Store Name"
                  fullWidth
                />
              </div>

              {/* BIO */}

              {/* STORE OPENING TIME */}
              <div className="control_group w_33">
                <label htmlFor="storeOpeningTime">Store Opening Time</label>
                <TextField
                  id="storeOpeningTime"
                  name="storeOpeningTime"
                  type="time"
                  fullWidth
                />
              </div>

              {/* STORE CLOSING TIME */}
              <div className="control_group w_33">
                <label htmlFor="storeClosingTime">Store Closing Time</label>
                <TextField
                  id="storeClosingTime"
                  name="storeClosingTime"
                  type="time"
                  fullWidth
                />
              </div>
              <div className="control_group w_100">
                <label htmlFor="bio">Bio</label>
                <TextField
                  id="bio"
                  name="bio"
                  placeholder="Enter Bio"
                  fullWidth
                  multiline
                  rows={3}
                />
              </div>

              {/* SUBMIT BUTTON */}
              <div className="form_btn">
                <Button className="btn btn_primary" variant="contained" onClick={handleNextTab}>
                  Next
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={1}>
          <form className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="storeName">Address line 1</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Address"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="storeName">Address line 2</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Address"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="storeName">City</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter City"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="storeName">State</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter State"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="storeName">Country</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Country"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="storeName">Zip Code</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Zip Code"
                  fullWidth
                />
              </div>

              <div className="form_btn">
                <Button className="btn btn_primary" variant="contained" onClick={handleNextTab}>
                  Next
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <form className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="storeName">Bank Name</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Bank Name"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="storeName">Account Holder’s Name</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Account Holder’s Name"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="storeName">Branch name</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Branch name
"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="storeName">Bank Code</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Bank Code
"
                  fullWidth
                />
              </div>

              <div className="form_btn">
                <Button className="btn btn_primary" variant="contained" onClick={handleNextTab}>
                  Next
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <form className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="storeName"> Name of Document</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Name"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="storeName">Expiry Date</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Expiry Date"
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label htmlFor="icon-button-file">Upload Front Image</label>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = (event.target as HTMLInputElement).files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage("This field only accepts images.");
                        }
                      }}
                    />
                    <span className="upload_image_holder square">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="icon" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
              <div className="control_group w_50">
                <label htmlFor="icon-button-file">Upload Back Image</label>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = (event.target as HTMLInputElement).files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage("This field only accepts images.");
                        }
                      }}
                    />
                    <span className="upload_image_holder square">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="icon" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              <div className="form_btn">
                <Button className="btn btn_primary" variant="contained" onClick={handleNextTab}>
                  Next
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default EditProfile;
